import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Box = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsxs("g", { fillRule: "evenodd", children: [_jsx("path", { d: "M11.784 4.47a1.25 1.25 0 0 1 1.662-.602l5.782 2.704a1.25 1.25 0 1 1-1.059 2.265l-5.782-2.705a1.25 1.25 0 0 1-.603-1.662" }), _jsx("path", { d: "M.833 6.667A.833.833 0 0 0 0 7.5v10.417c0 .46.373.833.833.833h18.334c.46 0 .833-.373.833-.833V7.5a.833.833 0 0 0-.833-.833zm.834 1.666h5.852c.201.486.282 1.052.282 1.619 0 2.428-1.977 4.45-4.44 4.45-.544 0-1.21-.06-1.694-.242z" }), _jsx("path", { d: "M9.931 3.215a1.25 1.25 0 0 0-1.37-2.09L.583 6.353a1.25 1.25 0 0 0 1.084 2.23v-.25h.456z" })] }) }));
});
Box.displayName = 'Box';
export default Box;
//# sourceMappingURL=Box.js.map